<template>
    <el-dialog custom-class="dialogForm" class="measDialog" :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" width="80%" :title="title">
        <el-scrollbar class="dialogContentScroll">
            <el-form :model="form" ref="form" :rules="rules">
                <el-form-item label="老师名称" prop="orgname">
                    <el-input v-model="form.orgname" maxlength="20" show-word-limit placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item label="头像" prop="logoid">
                    <div class="flex al-c">
                        <div class="uploadItem">
                            <UploadFile ref="uploadFile" accept=".png,.jpg,.jpeg" :show-file-list="false" :fileMaxSize="5120" :scope-type="106" @success="coverattUploadSuccess">
                                <div class="noCoveratturl" v-if="!form.logourl">
                                    <i class="el-icon-plus"></i>
                                    <div class="label">上传图片</div>
                                </div>
                                <div v-else style="position: relative;">
                                    <img class="coveratturl" :src="form.logourl + '?v=' + now" alt="">
                                    <div class="del" @click.stop="deletImg">
                                        x
                                    </div>
                                </div>
                            </UploadFile>
                        </div>
                        <div class="flex al-c">
                            <p class="imgdesp">建议尺寸 180*180px，JPG、PNG 格式， 图片小于 5M。</p>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="机构名称" prop="propname">
                    <el-input v-model="form.propname" placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item label="职位" prop="dutyname">
                    <el-input v-model="form.dutyname" placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item label="简介" prop="orgdesp">
                    <el-input v-model="form.orgdesp" type="textarea" show-word-limit autosize maxlength="1000" placeholder="请输入"></el-input>
                </el-form-item>
            </el-form>
        </el-scrollbar>
        <div slot="footer" style="text-align:right">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" :loading="isLoading" @click="saveTeacher">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { getTeacherDetails, saveTeacher } from '@/api/measApi/teacherManage.js'
import UploadFile from '@/components/measComponents/uploadFile/uploadFile.vue'
export default {
  data() {
    return {
      visible: false,
      title: '新增老师',
      form: {
        dutyname: '', // 职位名称
        logoid: '', // 老师LogoID
        logourl: '', // 老师logourl
        code: '',
        orgdesp: '', // 老师介绍
        orgname: '', // 老师姓名
        propname: '' // 所在机构名称
      },
      rules: {
        orgname: [
          { required: true, message: '请输入老师名称', trigger: 'blur' }
        ]
      },
      uploadType: {
        catecode: 106,
        datatype: 'IMAGE',
        attid: '',
        url: ''
      },
      orgForm: {},
      isLoading: false,
      now: new Date().getTime()
    }
  },
  components: {
    UploadFile
  },
  methods: {
    handleOpen(code) {
      this.visible = true
      this.orgForm = JSON.parse(JSON.stringify(this.form))
      if (code) {
        this.title = '编辑老师'
        getTeacherDetails({ code: code }).then(res => {
          if (res.code === '000') {
            this.form = res.data
          }
        })
      } else {
        this.title = '新增老师'
      }
    },
    // 上传成功
    coverattUploadSuccess(file) {
      this.form.logoid = file.key
      this.form.logourl = file.atturl
      this.now = new Date().getTime()
    },
    // 删除照片
    deletImg() {
      this.form.logoid = ''
      this.form.logourl = ''
    },
    // 保存
    saveTeacher() {
      this.$refs.form.validate(validate => {
        if (validate) {
          this.isLoading = true
          saveTeacher(this.form).then(res => {
            if (res.code === '000') {
              this.$message.success(res.msg)
              this.$emit('saveSuccess')
              this.isLoading = false
              this.handleClose()
            }
          })
        }
      })
    },
    handleClose() {
      if (this.isLoading) {
        this.$message.warning('提交数据中，请稍等')
        return
      }
      this.visible = false
      this.form = this.orgForm
      this.$refs.uploadFile.clearFiles()
      this.$refs.form.clearValidate()
    }
  }
}
</script>
<style lang="scss" scoped>
.uploadItem {
  margin-right: 10px;
  width: 80px;
  height: 80px;
  .noCoveratturl {
    cursor: pointer;
    width: 80px;
    height: 80px;
    background: #d9d9d9;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .el-icon-plus {
      font-size: 20px;
      color: #fff;
    }
    .label {
      font-size: 12px;
      color: #666666;
      line-height: 24px;
    }
  }
  .coveratturl {
    width: 80px;
    height: 80px;
    cursor: pointer;
  }
  .del {
    position: absolute;
    right: -7px;
    top: -9px;
    background-color: #e66271;
    width: 18px;
    height: 18x;
    border-radius: 50%;
    line-height: 18px;
    font-size: 13px;
    cursor: pointer;
    color: #fff;
    z-index: 22;
  }
}
.imgdesp {
  font-size: 14px;
  line-height: 80px;
  color: #d8d8d8;
}
</style>

